// extracted by mini-css-extract-plugin
export var alertIcon = "_qc-0";